/* eslint-disable @typescript-eslint/no-unused-vars */
import { isDebug, lmsRequired, debugCompanyID } from './App.config'
import { retrieveParamByName } from './utils/Utils'

export const lmsCSS = 'padding: 2px 4px; color: SteelBlue; font-size: 12px; border-left: 2px solid GoldenRod'

type LMSLessonMode = 'normal' | 'browse' | 'review'

export enum LMSLessonStatus {
    Passed = 1,
    Completed = 2,
    Failed = 3,
    Incomplete = 4,
    Browsed = 5,
    NotAttempted = 6
}

export const getCompanyID = () => {
    const url = window.parent.location.href
    let val = retrieveParamByName('accountId', url)
    if (val === null) val = debugCompanyID // Need to throw an error if null and in Production.
    return val
}

export const init = (): boolean => {
    const isLMSAvailable = isAvailable()
    if (!isLMSAvailable && lmsRequired) throw new Error('LMS not found.')
    if (isDebug && !isLMSAvailable && !lmsRequired) console.warn('LMS Unavailable')
    return isLMSAvailable
}

export const concedeControl = (): void => {
    const user = getStudentName()
    console.log(`%cGoodbye ${user}! Closing window...`, lmsCSS)
    window.SCORMDriver.ConcedeControl()
}

export const getModuleScore = (): number => {
    const sessionScore = window.SCORMDriver.GetScore()
    isDebug && console.log(`%cLMS Session score: ${sessionScore}`, lmsCSS)
    if (sessionScore !== '') return Number(sessionScore)

    const suspendedScore = getSuspendData()
    isDebug && console.log(`%cLMSSuspended score: ${suspendedScore}`, lmsCSS)
    return suspendedScore === ''
        ? 0
        : Number(suspendedScore)
}

export const isAvailable = (): boolean => {
    const lmsStatus: any = getStudentID()
    if (!lmsStatus) return false
    return true
}

export const getLessonMode = (): LMSLessonMode => {
    return window.SCORMDriver.GetLessonMode()
}

const setModuleScore = (score: number): void => {
    setSessionScore(score)
    setSuspendData(score)
}

export const setSessionScore = (score: number): void => {
    window.SCORMDriver.SetScore(score, 100, 0)
}

export const resetStatus = (): void => {
    window.SCORMDriver.ResetStatus()
}

const setPassed = (): void => {
    window.SCORMDriver.SetPassed()
    commitData()
}

// const setFailed = (): void => {
//     window.SCORMDriver.SetFailed()
//     commitData()
// }

export const setReachedEnd = (): void => {
    window.SCORMDriver.SetReachedEnd()
    commitData()
}

export const commitData = (): void => {
    isDebug && console.log('%cLMS Committing data...', lmsCSS)
    window.SCORMDriver.CommitData()
}

export const setBookmark = (val: string): void => {
    window.SCORMDriver.SetBookmark(val)
}

const setSuspendData = (val: any): void => {
    window.SCORMDriver.SetSuspendData(val)
    commitData()
}

export const getBookmark = (): string => {
    return window.SCORMDriver.GetBookmark()
}

const getSuspendData = (): string => {
    return window.SCORMDriver.GetSuspendData()
}

const getStatus = (): any => {
    return window.SCORMDriver.GetStatus()
}

export const lessonStatus = (): LMSLessonStatus | undefined => {
    if (isAvailable()) {
        const lessonStatus: LMSLessonStatus = getStatus()
        isDebug && console.log('LMS lesson status:', lessonStatus)
        return lessonStatus
    }
    return undefined
}

export const getStudentID = (): any => {
    return window.SCORMDriver.GetStudentID()
}

export const getStudentName = (): string => {
    return window.SCORMDriver.GetStudentName()
}

export const getSessionAccumulatedTime = (): number => {
    return window.GetSessionAccumulatedTime()
}

export const incrementScore = (scoreIncrement: number) => {
    try {
        const currentScore = getModuleScore()
        isDebug && console.log(`%cUpdating score. Previous score:${currentScore}`, lmsCSS)
        const newScore: number = currentScore + scoreIncrement
        if (newScore > 0) {
            setModuleScore(Math.min(newScore, 100))
            const modScore = getModuleScore()
            console.log(`%cNew score: ${modScore}`, lmsCSS)
        }
        else {
            const msg = `Score must be greater than zero. ${newScore}`
            throw new Error(msg)
        }
    }
    catch (error) {
        console.error(error)
    }
}

export const setModulePassed = () => {
    const status = getStatus()
    if (status !== LMSLessonStatus.Passed) { // If not already Passed                
        isDebug && console.log(`%cSetting LMS Lesson status to ${LMSLessonStatus.Passed}`, lmsCSS)
        setPassed()
    }
    const newStatus = getStatus()
    const score = getModuleScore()
    isDebug && console.log(`%cYour lesson status is:${newStatus}`, lmsCSS)
    isDebug && console.log(`%cYour score is: ${score}`, lmsCSS)
}